import mapToObject from '../util/map-to-object';

const PerformanceMetricsProperties = [
  'Downloads',
  'FirstLaunches',
  'Purchases',
  'Subscriptions',
  'PostClickDownloadRate',
  'CostPerDownload',
  'PostClickFirstLaunchRate',
  'CostPerFirstLaunch',
  'PostInstallPurchaseRate',
  'CostPerPurchase',
  'PostInstallSubscriptionRate',
  'CostPerSubscription',
];

export default mapToObject(PerformanceMetricsProperties, property => `PerformanceMetrics/${property}`);
